module.exports = __webpack_public_path__ + "static/media/samsung_card_front.6fa05f22.png";